import { callApi } from '@local_modules/generic/fetch.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

export async function showMissingJournals (accountingOrganisationId) {
  const url = '/api/data-review/entity-missing-journal-numbers/:accountingOrganisationId'
  const apiResponse = await callApi(url, {
    accountingOrganisationId
  })
  console.log('apiResponse', apiResponse)

  const missingJournalNumbers = apiResponse?.map(record => record.expected_number)

  if (missingJournalNumbers.length === 0) {
    setElementHtml('missingJournals', 'No missing journal numbers')
  } else {
    setElementHtml('missingJournals', `<span class="tag is-warning">${missingJournalNumbers.length}</span> [<a href="/app/admin/entity/${accountingOrganisationId}/missing-journal-numbers">Details</a>] ${missingJournalNumbers.join(', ')}`)
  }
}
